import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import type { useStripe } from '@/hooks/payments/useStripe';

import type { GetCashAppPaymentIntentResponse } from './types';

async function fetchCashAppPaymentIntent(
  stripe: ReturnType<typeof useStripe> | null,
  returnUrl: string,
) {
  const paymentMethodresponse = await stripe?.createPaymentMethod({
    type: 'cashapp',
  });

  if (!paymentMethodresponse?.paymentMethod) {
    throw new Error('Payment method not created');
  }

  const paymentMethod = paymentMethodresponse.paymentMethod;

  const response = await apiClient.post<GetCashAppPaymentIntentResponse>(
    '/v1/payment/setup-intent',
    {
      returnUrl,
      confirm: true,
      sourceId: paymentMethod.id,
    },
  );
  return response.data;
}

// Prefix of every cash-app intent query, for eviction after a failed attempt
export const CASH_APP_PAYMENT_INTENT_QUERY_KEY = ['cash-app-payment-intent'];

export const getCashAppPaymentIntentQuery = (
  stripe: ReturnType<typeof useStripe> | null,
  returnUrl: string,
) => {
  return queryOptions({
    refetchOnMount: true,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    enabled: !!returnUrl && !!stripe,
    queryKey: [...CASH_APP_PAYMENT_INTENT_QUERY_KEY, returnUrl, 's'],
    queryFn: () => fetchCashAppPaymentIntent(stripe, returnUrl),
    // Single-use: a confirmed intent must never be hydrated into a later session
    meta: { persist: false },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
